// extracted by mini-css-extract-plugin
export default {"pageContainer":"privacy-policy_pageContainer__a6+Ih"};